import { h, defineComponent } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';

export enum Type {
  Included = 'included',
  Excluded = 'excluded',
  Undetermined = 'undetermined',
}

export interface CheckboxListResource {
  type: Type;
  text: string;
}

interface ChecklistProps {
  list: CheckboxListResource[];
  shadowed: boolean;
}

export const checklistEntry = (text: string) => ({
  type: Type.Included,
  text,
});

const icon = (type: string) => {
  const classes = `checkbox-list__${type}`;
  const faIcon = type === Type.Excluded ? 'times' : 'check';
  const iconPack = type === Type.Excluded ? 'far' : 'fas';

  return h(
    'div',
    { attrs: { class: classes } },
    [h(Icon, { props: { icon: faIcon, iconPack, classes: 'checkbox-list__icon' } })],
  );
};

export const CheckboxList = defineComponent<ChecklistProps>({
  props: ['list', 'shadowed'],
  setup(props) {
    return function render() {
      return h(
        'div',
        { class: `checkbox-list ${props.shadowed ? 'checkbox-list--shadowed' : ''}` },
        props.list.map(check => {
          return [
            h('div', { class: 'checkbox-list__point-container' }, [
              h('div', { class: `checkbox-list__icon-container checkbox-list__icon-container--${check.type}` }, [
                icon(check.type),
              ]),
              h('div', check.text),
            ]),
          ];
        }),
      );
    };
  },
});
